// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1O8CcGX5CH45RK {\n  padding: 0 2px;\n  background-color: rgba(9, 30, 66, 0.04);\n  border-radius: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  width: 100%;\n  height: 100%;\n}\n._1O8CcGX5CH45RK:not(.CeZAu_5Guu9gAp) ._3POLJs9ltsZW9p {\n  margin-right: 4px;\n}\n._1O8CcGX5CH45RK._3-T6IXCVwcSp2D {\n  color: #FFFFFF;\n  background-color: #61BD4F;\n}\n._1O8CcGX5CH45RK._3wYTcaMsoIMwWA {\n  color: #FFFFFF;\n  background-color: #F2D600;\n}\n._1O8CcGX5CH45RK._36Qf5c4MPSdZPj {\n  color: #FFFFFF;\n  background-color: #EB5A46;\n}\n._1O8CcGX5CH45RK._2ZzUo6PZ8uavcC {\n  color: #FFFFFF;\n  background-color: #EC9488;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": "_1O8CcGX5CH45RK",
	"unset": "CeZAu_5Guu9gAp",
	"icon": "_3POLJs9ltsZW9p",
	"is-due-complete": "_3-T6IXCVwcSp2D",
	"is-due-soon": "_3wYTcaMsoIMwWA",
	"is-due-now": "_36Qf5c4MPSdZPj",
	"is-due-past": "_2ZzUo6PZ8uavcC"
};
export default ___CSS_LOADER_EXPORT___;
